import { ShareLogWorkstation } from '@/modules/Workstation'
import styles from './SharedLogPage.module.scss'
import { CombinedLogsShared } from '@/modules/CombinedLogs'
import { Mileage } from '@/modules/Mileage'
import { useGetAreas } from '@/modules/Areas'
import { Loader } from '@/ui/Loader'

export const SharedLogPage = () => {
    const { isLoading } = useGetAreas()

    if (isLoading)
        return (
            <section className={styles.root}>
                <Loader />
            </section>
        )

    return (
        <section className={styles.root}>
            <div className={styles.header}>
                <ShareLogWorkstation />
                <Mileage displayed={true} />
            </div>

            <CombinedLogsShared />
        </section>
    )
}
